"use strict";
/**
 *
 * RowSticky
 *
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const clsx_1 = __importDefault(require("clsx"));
// decorate
const decorate_1 = __importDefault(require("./decorate"));
function makeRowSticky(_0) {
    const RowSticky = react_1.default.forwardRef(function RowSticky(props, ref) {
        const { children, classes, className, component: Component = 'div' } = props;
        return (react_1.default.createElement(Component, { className: clsx_1.default(classes.root, className), role: "row", ref: ref }, children));
    });
    if (process.env.NODE_ENV !== 'production') {
        RowSticky.displayName = 'RowSticky';
    }
    return react_1.default.memo(decorate_1.default(RowSticky));
}
exports.makeRowSticky = makeRowSticky;
